import type { Tokens } from '../augmentation'
import { spacing } from '../spacing'
import { type ComponentCreation } from './types'

export const createMuiTabs = ({ palette }: Pick<Tokens, 'palette'>) =>
  ({
    MuiTabs: {
      defaultProps: {},
      styleOverrides: {
        root: {
          height: spacing(6),
          minHeight: spacing(6),
        },
        scroller: {
          boxShadow: `inset 0px -1px 0px ${palette.components.divider.line}`,
        },

        indicator: {
          backgroundColor: palette.components.tab.selected,
        },
      },
    },
  }) satisfies ComponentCreation
